import CashInput from './CashInput';

export default CashInput;
